import { Building2, Hand } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import Icon from '@/components/primitives/Icon.jsx';
import Spinner from '@/components/primitives/Spinner.jsx';
import Badge from '@/components/primitives/Badge.jsx';
import formatRelativeTime from '@/lib/dates/formatRelativeTime.js';
import { AUTOMATION_BUILDER_KIND_BY_THREAD_TYPE } from '@/lib/threads/threadTypeValues.js';

/** One conversation in a list: its title, the automation kind it builds, when it last moved, and a mark when Pieve is working or waiting for the person. */
const ThreadListItem = ({ item }) => {
  const isWaiting = item.hasPendingInteraction || item.awaitingApproval;
  const automationKind = AUTOMATION_BUILDER_KIND_BY_THREAD_TYPE[item.threadType];

  return (
    <li>
      <NavLink to={`/threads/${item.id}`} className="assistant-thread-item">
        <span className="assistant-thread-item__mark" data-state={isWaiting ? 'waiting' : item.inProgress ? 'running' : undefined}>
          {isWaiting ? <Icon icon={Hand} size="sm" label="Waiting for you" /> : item.inProgress ? <Spinner size={14} label="Running" /> : item.hasUnopenedAssistantResponse ? <span className="assistant-thread-item__unread" aria-label="New reply" /> : null}
        </span>
        <span className="assistant-thread-item__title">{item.label || 'Untitled conversation'}</span>
        {automationKind && (
          <span className="assistant-thread-item__kind">
            <Badge tone="info">{automationKind}</Badge>
          </span>
        )}
        {item.isCompany && (
          <span className="assistant-thread-item__shared">
            <Icon icon={Building2} size="sm" label="Shared with your organization" />
          </span>
        )}
        <span className="assistant-thread-item__time">{formatRelativeTime(item.updatedAt || item.createdAt)}</span>
      </NavLink>
    </li>
  );
};

export default ThreadListItem;
